module.exports = __webpack_public_path__ + "static/media/background.28249dfe.png";